import {
  BRUNO_BOT_USER_ID,
  BRUNO_DISPLAY_NAME,
  isBrunoUserId,
} from '@shared/bruno/constants'
import type { ChatUser } from '../types/chat'
import brunoIconUrl from '../assets/bruno/bruno-icon.png'

/** Vite-bundled Bruno photo (nav + DM thread header). */
export const BRUNO_ICON_URL = brunoIconUrl

/** Resolve Bruno bot user id (env override for staging). */
export function resolveBrunoBotUserId(): string {
  const fromEnv = import.meta.env.VITE_BRUNO_BOT_USER_ID?.trim()
  return fromEnv || BRUNO_BOT_USER_ID
}

/** Feature flag — defaults to enabled when unset (dev-friendly). */
export function isBrunoEnabled(): boolean {
  const flag = import.meta.env.VITE_BRUNO_ENABLED?.trim().toLowerCase()
  if (flag === 'false' || flag === '0' || flag === 'no') return false
  return true
}

export function buildBrunoDirectoryStub() {
  return {
    userId: resolveBrunoBotUserId(),
    email: 'bruno-bot@ascendhealth.internal',
    displayName: BRUNO_DISPLAY_NAME,
    avatarUrl: BRUNO_ICON_URL,
    roleType: 'bot',
  }
}

/** Override backend dicebear avatar with the bundled Bruno photo. */
export function applyBrunoDirectoryStub(user: ChatUser): ChatUser {
  if (!isBrunoUserId(user.userId)) return user
  const stub = buildBrunoDirectoryStub()
  return { ...user, ...stub }
}

/** Mention picker directory — always includes Bruno with the local photo. */
export function buildMentionDirectory(users: ChatUser[]): ChatUser[] {
  const all = users.map(applyBrunoDirectoryStub)
  const brunoStub = buildBrunoDirectoryStub()
  if (!all.some((u) => u.userId === brunoStub.userId)) {
    all.unshift(brunoStub as ChatUser)
  }
  return all
}

/** Callable contact rosters — Bruno is chat-only, not voice/video. */
export function filterCallableContacts(users: ChatUser[]): ChatUser[] {
  return users.filter((u) => !isBrunoUserId(u.userId))
}
